import AttorneyBioTemplate from '@/components/AttorneyBioTemplate';
import { attorneys } from '@/data/attorneys';

export default function JacquelineBohatchPage() {
  return <AttorneyBioTemplate attorney={attorneys['jacqueline-bohatch-esq']} />;
}
